import type { ReportUserInput } from '../../lib/api';

export const REPORT_REASONS: { id: NonNullable<ReportUserInput['reason']>; label: string }[] = [
  { id: 'harassment', label: 'Harassment or bullying' },
  { id: 'hate_speech', label: 'Hate speech or slurs' },
  { id: 'inappropriate_name', label: 'Inappropriate name or photo' },
  { id: 'impersonation', label: 'Impersonation' },
  { id: 'spam', label: 'Spam' },
  { id: 'cheating', label: 'Cheating' },
  { id: 'other', label: 'Something else' }
];
